var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 237 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M234.991 77.55c12.339 32.933-54.729 63.171-84.835 65.748-30.022 2.706-85.79 6.5-123.86-35.677-37.962-42.334-11.057-118.548 74.655-86.476 85.78 32.162 121.778 23.579 134.04 56.405Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 228,
    height: 132,
    x: 9,
    y: 13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M234.992 77.55c12.338 32.933-54.729 63.171-84.836 65.748-30.022 2.706-85.79 6.5-123.86-35.677C-11.666 65.287 15.24-10.927 100.95 21.145c85.781 32.162 121.778 23.579 134.041 56.405Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M266.01 98.058s-46.019 13.409-130.845 24.456c-104.057 13.551-144.83 4.821-144.83 4.821l-24.645-20.158s196.059 5.437 274.567-6.632c26.963-4.145 25.753-2.487 25.753-2.487Z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M173.166 99.63h15.603l-.059-5.86h-15.603l.059 5.86Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M153.91 96.642c-1.579.08-2.828 2.795-2.79 6.065.038 3.271 1.35 5.857 2.929 5.778h2.864l-.331-7.225-2.672-4.618Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M160.068 102.419c-.039-3.27-1.35-5.857-2.93-5.777-1.579.08-2.828 2.795-2.789 6.065.038 3.271 1.349 5.858 2.928 5.778 1.58-.08 2.829-2.795 2.791-6.066ZM170.477 96.794c-1.58.08-2.829 2.795-2.791 6.065.039 3.271 1.351 5.858 2.93 5.778h2.864l-.332-7.226-2.671-4.617Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M176.634 102.571c-.038-3.27-1.35-5.857-2.929-5.777-1.579.08-2.829 2.795-2.79 6.065.038 3.27 1.35 5.858 2.929 5.778 1.579-.079 2.829-2.795 2.79-6.066Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M174.623 88.328h15.678l-3.723-19.95-11.955-.016v19.966Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M186.671 77.31v-8.17c0-.724-.534-.766-.534-.766h.529s9.152.42 9.147 6.056c-.002 3.398-3.284 4.04-3.284 4.04l-5.858-1.16Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M186.67 73.044v4.172h8.786c-.243-2.763-.093-4.171-1.338-4.171h-7.448Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M174.807 94.113h15.677l-1.986-19.966h-13.691v19.966Z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M177.254 95.638h12.576l1.076 2.6h-14.279l.627-2.6Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M191.096 94.113h-2.598V74.43h2.598v19.683Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 105,
    height: 46,
    x: 96,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M96.76 109.397h104.235V64.085H96.76v45.312Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M196.637 95.96h2.008v-2.518h-2.008v2.518Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M169.609 94.955h6.594l1.911 2.421H199.86l-4.366 6.336H164.24v-6.336l5.369-2.421Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M181.878 102.564h-1.199l-.314-1.438v-3.75h1.513v5.188Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M190.18 74.41v20.94l9.366 2.079.723-.939c.001-.452.003-.772.003-2.155a76.312 76.312 0 0 0-.194-5.133l-1.065-8.728.18-1.179c-.253-2.661-1.187-4.235-1.945-4.422-2.206-.544.352-.464-7.068-.464Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m198.725 81.086.272 3.05.413 4.642c.031.346.117.58.285.65.168.069.409.16.409.16l-.026-.386-.244-2.73-.535-5.988-.001-.005h-.411c-.125 0-.195.23-.162.607Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M200.473 91.811c.249 0 .453.203.453.45v3.791c0 .247-.204.45-.453.45h-.897c-.249 0-.648-.059-.887-.13l-1.778-.53a.644.644 0 0 1-.434-.578v-3.003c0-.247.204-.45.453-.45h3.543Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M190.123 78.037v-.39s9.35.117 9.318-.295c.136 1.007.546 2.28.676 3.65h-1.393l-.195-1.95-8.406-1.015Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M198.816 96.488v-5.326c0-.396-.028-1.042-.062-1.437l-.831-9.712a.804.804 0 0 0-.787-.717h-6.153a.724.724 0 0 0-.725.72V95.96",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0CA933",
    strokeWidth: 1.391,
    d: "M198.816 96.488v-5.326c0-.396-.028-1.042-.062-1.437l-.831-9.712a.804.804 0 0 0-.787-.717h-6.153a.724.724 0 0 0-.725.72V95.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M193.181 81.187v5.103c0 .395-.308.61-.683.475l-.868-.305c-.375-.135-.683-.566-.683-.962V81.24c0-.395.329-.726.727-.737l.782-.017a.703.703 0 0 1 .725.703ZM197.874 87.66c.029.369-.229.56-.578.423l-2.106-.827a1.05 1.05 0 0 1-.518-.497.917.917 0 0 1-.115-.426v-5.18a.68.68 0 0 1 .68-.674h1.366a.75.75 0 0 1 .735.672l.188 2.29.348 4.218Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0CA933",
    strokeWidth: 1.391,
    d: "M193.879 79.296v14.817"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M188.498 93.593v.54h4.796c.947 0 1.842 1.015 2.519 2.388.134.273.257.565.368.873h.469a9.753 9.753 0 0 0-.567-1.444c-.75-1.52-1.74-2.357-2.789-2.357h-4.796Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M191.962 97.417h-7.976v-1.436l10.427.788 1.617-.28h4.221v.928h-8.289Z",
    clipRule: "evenodd"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0B",
    fillRule: "evenodd",
    d: "M189.875 102.692a15.873 15.873 0 0 0 .022.836h.885a13.99 13.99 0 0 1-.028-.836c0-.46.025-.907.073-1.337.192-1.726.749-3.165 1.494-3.947h-1.436c-.487 1.075-.826 2.436-.954 3.947a15.76 15.76 0 0 0-.056 1.337Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M200.54 97.408c.25 0 .454.202.454.449v5.873c0 .248-.204.45-.454.45h-5.674a.453.453 0 0 1-.454-.45v-5.873c0-.247.204-.45.454-.45h5.674Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M197.443 101.76c-.135-1.59-.429-3.283-.941-4.415h-5.939c-.662 4.199-1.606 5.963-1.606 5.963s1.46.838 1.458.869h7.064c.004-.076.007-.281.01-.357a16.56 16.56 0 0 0-.046-2.06Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M187.674 74.135h10.574c1.338 0 1.282 1.925 1.585 5.118h-11.336v-3.657c0-1.483-.823-1.46-.823-1.46Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M191.01 94.953c-1.842-.093-3.408 2.6-3.758 6.217-.042.432-.066.878-.071 1.334-.004.281.001.91.012 1.185h2.802l2.992-3.563v-5.165l-1.977-.008Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0B",
    fillRule: "evenodd",
    d: "M195.069 98.09c-.559-.86-1.255-1.874-2.005-1.837-.75.038-1.89 1.122-2.429 2.038a6.68 6.68 0 0 0-.313.616l-.783-1.355c-1.579.08-2.829 2.796-2.79 6.065.038 3.271 1.35 5.858 2.929 5.778h2.864l-.331-7.225-1.311-2.266c.438-.939 1.047-1.538 1.725-1.572 1.37-.069 2.511 2.181 2.544 5.016.004.285-.004.565-.023.837l1.218-.038c.013-.274.018-.553.015-.837-.025-2.143-.536-4.03-1.31-5.22Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M192.77 97.552c-1.579.08-2.829 2.796-2.791 6.066.039 3.27 1.35 5.857 2.93 5.778 1.579-.08 2.829-2.796 2.79-6.067-.038-3.269-1.35-5.856-2.929-5.777Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M192.794 99.606c-1.03.052-1.848 1.829-1.823 3.962.026 2.133.884 3.826 1.914 3.774 1.03-.052 1.848-1.829 1.823-3.962-.025-2.133-.884-3.826-1.914-3.774Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M194.453 103.397c.004.326-.016.64-.056.938-.135 1.006-.502 1.818-.977 2.165a.879.879 0 0 1-.479.182.824.824 0 0 1-.482-.133c-.476-.294-.858-1.051-1.021-2.024a6.46 6.46 0 0 1-.022-1.952c.14-.996.508-1.795.982-2.132a.866.866 0 0 1 .468-.175.817.817 0 0 1 .471.128c.488.292.878 1.07 1.038 2.07.047.294.074.607.078.933Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "m196.213 104.147-.381.019.381-.019ZM196.73 103.285a15.568 15.568 0 0 0-.071-1.334c-.325-3.36-1.701-5.92-3.37-6.194l.037-.026-3.168.002c-1.23.062-2.378 1.355-3.081 3.298a12.323 12.323 0 0 0-.676 3.29c-.033.437-.046.883-.04 1.34 0 .067.002.132.003.199.006.214.015.427.028.636l2.893-.023.001.022.505-.025c-.02-.272-.032-.551-.035-.834-.026-2.144.441-4.08 1.185-5.345.539-.916 1.223-1.48 1.972-1.518.75-.037 1.446.457 2.006 1.318.773 1.19 1.284 3.075 1.31 5.219.003.283-.003.563-.016.837l.505-.026c.011-.274.016-.554.012-.836Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M193.325 95.731s-2.279-.147-3.124 2.315l-3.125.985c.704-1.943 1.851-3.236 3.081-3.298l3.168-.002Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M193.324 103.453c.001.088-.004.174-.015.255-.037.274-.137.495-.266.589a.24.24 0 0 1-.131.05.234.234 0 0 1-.131-.036c-.129-.08-.233-.286-.277-.551a1.709 1.709 0 0 1-.007-.531c.038-.271.139-.489.268-.581a.242.242 0 0 1 .127-.047.22.22 0 0 1 .128.035c.133.08.24.291.283.563.013.08.02.165.021.254Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0B",
    fillRule: "evenodd",
    d: "M176.542 98.09c-.559-.86-1.256-1.874-2.006-1.837-.749.038-1.89 1.122-2.428 2.038-.112.19-.215.398-.313.616l-.784-1.355c-1.579.08-2.828 2.796-2.789 6.065.038 3.271 1.349 5.858 2.929 5.778h2.864l-.332-7.225-1.311-2.266c.438-.939 1.047-1.538 1.726-1.572 1.37-.069 2.51 2.181 2.544 5.016.003.285-.005.565-.024.837l1.218-.038c.013-.274.019-.553.015-.837-.025-2.143-.536-4.03-1.309-5.22Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M174.242 97.552c-1.579.08-2.828 2.796-2.79 6.066.039 3.27 1.35 5.857 2.929 5.778 1.58-.08 2.829-2.796 2.791-6.067-.039-3.269-1.35-5.856-2.93-5.777Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M174.267 99.606c-1.03.052-1.848 1.829-1.823 3.962.025 2.133.883 3.826 1.913 3.774 1.031-.052 1.848-1.829 1.824-3.962-.026-2.133-.884-3.826-1.914-3.774Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M175.925 103.397c.004.326-.015.64-.056.938-.135 1.006-.501 1.818-.977 2.165a.879.879 0 0 1-.479.182.828.828 0 0 1-.482-.133c-.476-.294-.858-1.051-1.02-2.024a6.258 6.258 0 0 1-.084-.972 6.337 6.337 0 0 1 .061-.98c.14-.996.508-1.795.983-2.132a.866.866 0 0 1 .467-.175.82.82 0 0 1 .472.128c.488.292.877 1.07 1.037 2.07.047.294.074.607.078.933Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "m177.686 104.147-.381.019.381-.019ZM178.201 103.285a15.562 15.562 0 0 0-.072-1.334c-.324-3.36-1.7-5.92-3.369-6.194l.037-.026-3.169.002c-1.23.062-2.377 1.355-3.08 3.298-.35.962-.589 2.082-.677 3.29-.033.437-.045.883-.04 1.34 0 .067.002.132.004.199.005.214.014.427.027.636l2.893-.023.001.022.505-.025a15.037 15.037 0 0 1-.035-.834c-.025-2.144.441-4.08 1.186-5.345.538-.916 1.222-1.48 1.972-1.518.75-.037 1.446.457 2.005 1.318.774 1.19 1.285 3.075 1.31 5.219.003.283-.002.563-.016.837l.506-.026c.011-.274.015-.554.012-.836Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M174.798 95.731s-2.279-.147-3.125 2.315l-3.124.985c.703-1.943 1.851-3.236 3.081-3.298l3.168-.002Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M174.797 103.453c.001.088-.005.174-.016.255-.037.274-.136.495-.265.589a.24.24 0 0 1-.131.05.234.234 0 0 1-.131-.036c-.13-.08-.234-.286-.278-.551a1.709 1.709 0 0 1-.006-.531c.038-.271.139-.489.268-.581a.236.236 0 0 1 .127-.047.222.222 0 0 1 .128.035c.133.08.239.291.283.563.012.08.02.165.021.254Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M99.897 99.465h2.243v-5.024h-2.243v5.024ZM130.797 92.889v4.706c0 .19.157.345.348.345h38.846a.348.348 0 0 0 .349-.345V93.21",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M168.441 103.407a.748.748 0 0 1-.75.743h-10.134a.748.748 0 0 1-.75-.743v-6.166c0-.409.337-.743.75-.743h10.134c.413 0 .75.334.75.743v6.166Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M168.197 103.111c-.134.143-.58.259-.992.259h-7.808a.749.749 0 0 1-.75-.744v-5.378a.749.749 0 0 0-.75-.744h-1.67a.749.749 0 0 0-.75.744v6.165c0 .409.337.744.75.744h1.67c.413 0 .75-.002.75-.004s.338-.003.75-.003h7.808c.412 0 .858-.117.992-.259.133-.142.242-1.067.242-1.281 0-.215-.109.359-.242.501Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M154.707 101.051c0 .327.27.594.599.594h1.632c.33 0 .599-.206.599-.459v-6.207a.598.598 0 0 0-.599-.594h-1.632a.599.599 0 0 0-.599.594v6.072Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M154.627 94.283v3.927c0 .326.27.594.599.594h1.734c.329 0 .599-.207.599-.46v-4.061M134.555 96.716l1.083-3.5-.841-1.02-.98 3.162-.617 1.991-.639 2.065.842 1.016.462-1.49.69-2.224ZM124.388 95.986l.71-2.293.864 2.788c-.226.33-.435.706-.622 1.122-.271-.642-.593-1.188-.952-1.617Zm-8.785-.248.508-1.638.814 2.63a7.115 7.115 0 0 0-.297.535c-.297-.622-.643-1.14-1.025-1.527Zm15.863-.788h-1.89l-.852-2.753-.842 1.019.538 1.736h-.261c-.465.023-.917.224-1.339.567l-.045-.146-.984-3.176-.693.838-.694-.838-.932 3.009a1.993 1.993 0 0 0-.848-.252l.005-.004h-.176l-3.168.002c-.534.027-1.052.288-1.526.733l-.086-.278-.994-3.21-.568.687-.569-.687-.894 2.886a1.972 1.972 0 0 0-.386-.107l.036-.026-3.168.002c-.634.032-1.245.392-1.785.999l-.231-.744-.931-3.01-.842 1.019 1.021 3.295.188.607a8.608 8.608 0 0 0-.5 1.132l.077-.02c-.026.066-.053.132-.077.2-.35.963-.589 2.083-.677 3.291-.033.437-.045.883-.04 1.34 0 .066.002.132.004.199.005.213.014.427.027.636l.419-.004c.274 2.753 1.465 4.793 2.869 4.722h2.864l-.001-.035c.12.025.242.042.367.035 1.205-.06 2.216-1.658 2.611-3.864.413 2.307 1.496 3.927 2.75 3.864h2.833l-.009-.037c.123.027.247.044.375.037 1.186-.059 2.185-1.605 2.594-3.756.427 2.248 1.495 3.818 2.729 3.756h3.002s-1.981-8.74-2.316-10.282a6.65 6.65 0 0 1 .403-.822c.092-.157.163-.302.223-.437l.387 1.249.653 2.108.841-1.016-.771-2.489-.286-.924.088-.01 1.477-1.041ZM138.213 95.407l-.994-3.21-.568.687-.569-.687-1.033 3.334-.623 2.016-.578 1.867.841 1.016.373-1.202.707-2.28.882-2.847.831 2.68.571 1.843.559 1.806.843-1.016-.708-2.284-.534-1.723Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "m155.337 92.197-.979 3.161-.617 1.991-.639 2.064.842 1.017.462-1.49.69-2.224 1.083-3.5-.842-1.02ZM147.316 95.373l-.984-3.176-.693.838-.694-.838-.969 3.127-.615 1.989-.652 2.1.843 1.017.478-1.543.687-2.215.922-2.978.942 3.041.57 1.84.574 1.855.843-1.016-.718-2.318-.534-1.723ZM128.42 94.802c-.271.398-.668 1.024-.885 1.531l.72 2.242c.193-.56.579-1.228.85-1.648l-.685-2.125Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M97.147 93.117v2.485c0 .19.157.345.348.345h51.394a.348.348 0 0 0 .348-.345v-2.573",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M148.961 94.802c-.271.398-.668 1.024-.885 1.531l.72 2.242c.193-.56.579-1.228.85-1.648l-.685-2.125Z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0B",
    fillRule: "evenodd",
    d: "M153.171 97.31c-.56-.862-1.256-1.876-2.005-1.838-.75.038-1.891 1.121-2.429 2.037a6.25 6.25 0 0 0-.313.617l-.783-1.355c-1.579.08-2.829 2.796-2.791 6.065.039 3.271 1.35 5.858 2.93 5.778h2.864l-.332-7.225-1.311-2.266c.438-.94 1.047-1.538 1.726-1.572 1.369-.069 2.511 2.18 2.544 5.016.003.284-.005.564-.024.837l1.218-.039c.013-.273.019-.553.016-.836-.026-2.144-.537-4.03-1.31-5.22Z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M150.869 96.771c-1.579.08-2.828 2.796-2.79 6.065.038 3.271 1.35 5.858 2.929 5.778 1.58-.079 2.829-2.795 2.791-6.066-.039-3.27-1.35-5.856-2.93-5.777Z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M150.894 98.824c-1.03.052-1.848 1.829-1.823 3.962.025 2.133.883 3.827 1.914 3.775 1.03-.052 1.847-1.83 1.823-3.963-.025-2.133-.884-3.826-1.914-3.774Z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M152.554 102.615c.004.326-.015.641-.056.938-.135 1.007-.501 1.819-.976 2.166a.897.897 0 0 1-.479.182.838.838 0 0 1-.483-.134c-.476-.294-.858-1.05-1.02-2.024a6.237 6.237 0 0 1-.084-.972 6.45 6.45 0 0 1 .061-.979c.14-.997.508-1.795.982-2.132a.876.876 0 0 1 .469-.175.818.818 0 0 1 .471.127c.488.293.877 1.071 1.037 2.071.047.293.074.607.078.932Z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "m154.314 103.366-.38.019.38-.019ZM154.83 102.504a15.98 15.98 0 0 0-.072-1.334c-.324-3.36-1.7-5.921-3.37-6.194l.038-.026-3.169.002c-1.23.061-2.377 1.355-3.08 3.297a12.357 12.357 0 0 0-.677 3.291c-.032.437-.045.883-.04 1.339 0 .067.002.132.004.2.005.213.015.427.027.636l2.893-.023.001.022.505-.025a14.123 14.123 0 0 1-.035-.834c-.025-2.144.442-4.08 1.186-5.346.538-.916 1.222-1.479 1.972-1.517.75-.038 1.446.456 2.005 1.317.774 1.19 1.285 3.076 1.31 5.22.003.283-.002.563-.015.837l.505-.026c.011-.275.015-.555.012-.836Z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M151.427 94.95s-2.279-.148-3.125 2.315l-3.124.984c.703-1.942 1.851-3.235 3.08-3.297l3.169-.002Z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M151.426 102.672c.001.088-.005.174-.016.255-.037.274-.136.495-.266.589a.234.234 0 0 1-.13.05.226.226 0 0 1-.131-.037c-.13-.079-.234-.285-.278-.55a1.709 1.709 0 0 1-.006-.531c.038-.272.138-.489.267-.581a.243.243 0 0 1 .128-.048.24.24 0 0 1 .128.035c.133.08.239.292.282.564.013.08.021.165.022.254Z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0B",
    fillRule: "evenodd",
    d: "M144.628 97.31c-.559-.862-1.256-1.876-2.005-1.838-.75.038-1.891 1.121-2.429 2.037a6.25 6.25 0 0 0-.313.617l-.783-1.355c-1.579.08-2.829 2.796-2.79 6.065.038 3.271 1.349 5.858 2.929 5.778h2.864l-.332-7.225-1.311-2.266c.439-.94 1.047-1.538 1.726-1.572 1.369-.069 2.511 2.18 2.544 5.016.003.284-.005.564-.024.837l1.218-.039c.013-.273.019-.553.016-.836-.026-2.144-.537-4.03-1.31-5.22Z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M142.328 96.771c-1.579.08-2.828 2.796-2.79 6.065.038 3.271 1.35 5.858 2.929 5.778 1.58-.079 2.829-2.795 2.791-6.066-.039-3.27-1.35-5.856-2.93-5.777Z",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M142.353 98.824c-1.03.052-1.848 1.829-1.823 3.962.025 2.133.883 3.827 1.914 3.775 1.03-.052 1.847-1.83 1.823-3.963-.025-2.133-.884-3.826-1.914-3.774Z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M144.011 102.615c.004.326-.015.641-.056.938-.135 1.007-.501 1.819-.976 2.166a.897.897 0 0 1-.479.182.838.838 0 0 1-.483-.134c-.476-.294-.858-1.05-1.02-2.024a6.237 6.237 0 0 1-.084-.972 6.45 6.45 0 0 1 .061-.979c.14-.997.508-1.795.982-2.132a.876.876 0 0 1 .469-.175.818.818 0 0 1 .471.127c.488.293.877 1.071 1.037 2.071.047.293.074.607.078.932Z",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "m145.771 103.366-.38.019.38-.019ZM146.287 102.504a15.98 15.98 0 0 0-.072-1.334c-.324-3.36-1.7-5.921-3.37-6.194l.038-.026-3.169.002c-1.23.061-2.377 1.355-3.08 3.297a12.357 12.357 0 0 0-.677 3.291c-.032.437-.045.883-.04 1.339 0 .067.002.132.004.2.005.213.015.427.027.636l2.893-.023.001.022.505-.025a14.123 14.123 0 0 1-.035-.834c-.025-2.144.442-4.08 1.186-5.346.539-.916 1.222-1.479 1.972-1.517.75-.038 1.446.456 2.005 1.317.774 1.19 1.285 3.076 1.31 5.22.003.283-.002.563-.015.837l.505-.026c.011-.275.015-.555.012-.836Z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M142.884 94.95s-2.279-.148-3.125 2.315l-3.124.984c.703-1.942 1.851-3.235 3.08-3.297l3.169-.002Z",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M142.883 102.672c.001.088-.005.174-.016.255-.037.274-.136.495-.266.589a.234.234 0 0 1-.13.05.226.226 0 0 1-.131-.037c-.13-.079-.234-.285-.278-.55a1.709 1.709 0 0 1-.006-.531c.038-.272.138-.489.267-.581a.243.243 0 0 1 .128-.048.24.24 0 0 1 .128.035c.133.08.239.292.282.564.013.08.021.165.022.254Z",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0B",
    fillRule: "evenodd",
    d: "M136.087 97.31c-.559-.862-1.256-1.876-2.005-1.838-.75.038-1.891 1.121-2.429 2.037a6.25 6.25 0 0 0-.313.617l-.783-1.355c-1.579.08-2.829 2.796-2.791 6.065.039 3.271 1.35 5.858 2.93 5.778h2.864l-.332-7.225-1.311-2.266c.439-.94 1.047-1.538 1.726-1.572 1.369-.069 2.511 2.18 2.544 5.016.003.284-.005.564-.024.837l1.218-.039c.013-.273.019-.553.016-.836-.026-2.144-.537-4.03-1.31-5.22Z",
    clipRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M133.785 96.771c-1.579.08-2.828 2.796-2.79 6.065.038 3.271 1.35 5.858 2.93 5.778 1.579-.079 2.828-2.795 2.79-6.066-.039-3.27-1.35-5.856-2.93-5.777Z",
    clipRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M133.81 98.824c-1.03.052-1.848 1.829-1.823 3.962.025 2.133.883 3.827 1.914 3.775 1.03-.052 1.848-1.83 1.823-3.963-.025-2.133-.884-3.826-1.914-3.774Z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M135.468 102.615c.004.326-.015.641-.056.938-.135 1.007-.501 1.819-.976 2.166a.897.897 0 0 1-.479.182.838.838 0 0 1-.483-.134c-.476-.294-.858-1.05-1.02-2.024a6.36 6.36 0 0 1-.084-.972 6.45 6.45 0 0 1 .061-.979c.14-.997.508-1.795.982-2.132a.876.876 0 0 1 .469-.175.818.818 0 0 1 .471.127c.488.293.877 1.071 1.037 2.071.047.293.074.607.078.932Z",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "m137.229 103.366-.381.019.381-.019ZM137.746 102.504a15.98 15.98 0 0 0-.072-1.334c-.324-3.36-1.7-5.921-3.37-6.194l.038-.026-3.169.002c-1.23.061-2.377 1.355-3.08 3.297a12.357 12.357 0 0 0-.677 3.291c-.032.437-.045.883-.04 1.339 0 .067.002.132.004.2.005.213.015.427.027.636l2.893-.023.001.022.505-.025a14.123 14.123 0 0 1-.035-.834c-.025-2.144.442-4.08 1.186-5.346.538-.916 1.222-1.479 1.972-1.517.75-.038 1.446.456 2.005 1.317.774 1.19 1.285 3.076 1.31 5.22.003.283-.002.563-.015.837l.505-.026c.011-.275.015-.555.012-.836Z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M134.341 94.95s-2.279-.148-3.125 2.315l-3.124.984c.703-1.942 1.851-3.235 3.08-3.297l3.169-.002Z",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M134.342 102.672c.001.088-.005.174-.016.255-.037.274-.136.495-.266.589a.234.234 0 0 1-.13.05.226.226 0 0 1-.131-.037c-.13-.079-.234-.285-.278-.55a1.709 1.709 0 0 1-.006-.531c.038-.272.138-.489.267-.581a.243.243 0 0 1 .128-.048.24.24 0 0 1 .128.035c.133.08.239.292.282.564.013.08.021.165.022.254Z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#313336",
    fillRule: "evenodd",
    d: "M118.535 99.284h2.244v-5.025h-2.244v5.025Z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M98.41 93.548c-.697 0-1.267-.466-1.267-1.036v-27.39c0-.57.57-1.037 1.267-1.037h76.397c.696 0 9.445.467 9.445 1.036v27.39c0 .57-3.011 1.037-3.708 1.037H98.41Z",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M98.324 91.649h24.107V65.792H98.324V91.65Z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "#929AA1",
    d: "M98.324 91.649h24.107V65.792H98.324V91.65Z",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M124.602 93.647c-.575 0-1.045-.457-1.045-1.014V65.846c0-.558.47-1.013 1.045-1.013h59.145c.574 0 1.045.456 1.045 1.013v26.787c0 .558-.471 1.014-1.045 1.014h-59.145Z",
    clipRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M97.115 94.343h26.543v-1.46H97.115v1.46Z",
    clipRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M123.209 94.344h62.342v-1.46h-62.342v1.46Z",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M96.76 101.368h26.973v-2.833H96.76v2.833Z",
    clipRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M96.76 102.771h26.973v-2.833H96.76v2.833Z",
    clipRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M122.887 98.535V102.77h1.611V98.535h-1.611Z",
    clipRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M100.359 100.921c0-.2-.165-.363-.366-.363h-2.03c-.201 0-.365.163-.365.363v.867c0 .2.164.363.365.363h2.03a.366.366 0 0 0 .366-.363v-.867Z",
    clipRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M112.601 100.739a.182.182 0 0 0-.182-.181h-5.806a.183.183 0 0 0-.183.181v1.049c0 .1.082.182.183.182h5.806c.1 0 .182-.082.182-.182v-1.049Z",
    clipRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M121.919 100.921c0-.2-.164-.363-.365-.363h-2.03a.366.366 0 0 0-.366.363v.867c0 .2.165.363.366.363h2.03a.365.365 0 0 0 .365-.363v-.867Z",
    clipRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0CA933",
    strokeWidth: 1.391,
    d: "M199.849 79.296H188.52"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M187.678 102.55h-4.884v-6.141h-2.466v6.928h2.466v-.008h4.96c.39 0 .42-.387.42-1.15v-.779c0 .633-.223 1.15-.496 1.15Z",
    clipRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillRule: "evenodd",
    d: "M188.175 101.821a.748.748 0 0 1-.75.743h-5.2a.748.748 0 0 1-.75-.743v-4.675c0-.41.337-.744.75-.744h5.2c.413 0 .75.335.75.744v4.675Z",
    clipRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M179.854 101.273c.043.325.347.59.677.59h.77c.33 0 .599-.207.599-.459V97.821a.598.598 0 0 0-.599-.594h-1.38a.51.51 0 0 0-.521.59l.454 3.456Z",
    clipRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#929AA1",
    d: "M109.875 65.792V91.65"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA1",
    fillRule: "evenodd",
    d: "M107.896 80.14h.95v-2.45h-.95v2.45ZM111.01 80.14h.949v-2.45h-.949v2.45ZM25.042 95.845c.03-.14.05-.282.059-.427.008-.132.001-.263-.005-.394.634-1.07.775-2.432.188-3.58-.624-1.219-1.995-1.962-3.368-2.005a3.184 3.184 0 0 0-1.08-.554c-.654-.178-1.287-.115-1.91.127-.177.068-.342.15-.506.238a1.759 1.759 0 0 0-.876-.522c-.01-.003-.019-.003-.028-.005-1.277-1.413-3.289-2.224-5.17-1.725-1.946.516-2.96 2.248-2.852 3.939-2.251.956-4.055 2.593-3.986 4.8.027.875.413 1.62 1.007 2.206l-.001.006c-.982 1.116-1.336 2.778-.496 4.134.697 1.126 1.931 1.646 3.155 1.606 1.531 1.519 3.755 1.953 5.695 1.294a4.5 4.5 0 0 0 1.833-.616c2.846 2.047 7.755 1.961 8.248-1.984.117-.941-.093-1.671-.499-2.215.9-.367 1.423-1.247 1.501-2.196.068-.825-.304-1.59-.91-2.127ZM88.077 104.681a2.639 2.639 0 0 0-.492-.374c-.24-.848-.781-1.529-1.745-1.714-1.425-.273-2.596.797-3.157 2.114-.407.266-.772.62-1.038.987-.843 1.158-.88 2.737.244 3.708 1.022.884 2.596 1.113 3.864.949.603-.078 1.144-.399 1.41-.929.09-.044.183-.079.264-.131 1.535-.963 2.047-3.253.65-4.61ZM62.931 101.818a3.581 3.581 0 0 0-.079-.541 3.177 3.177 0 0 0-.188-.449 1.836 1.836 0 0 0-.523-.603 1.339 1.339 0 0 0-.126-.267c-.246-.384-.612-.721-1.069-.825a1.962 1.962 0 0 0-1.377.18l-.415.21c-.125-1.123-1.101-1.905-2.246-1.626-.762.185-1.27.64-1.565 1.247a1.694 1.694 0 0 0-.366-.02c-.637-.562-1.605-.728-2.371.058-.82.841-1.5 1.899-1.472 3.12.017.751.308 1.494.797 2.058-.325.784-.319 1.702.096 2.455.373.675 1.095 1.131 1.856 1.22.564.192 1.17.116 1.683-.152.4.593 1.058.946 1.789.947 1.107.002 2-.615 2.529-1.461.156-.013.317-.041.48-.096.385-.13.733-.38.977-.705.85-.603 1.36-1.629.972-2.716a2.121 2.121 0 0 0-.17-.357c.059-.048.119-.097.16-.134.01-.011.021-.019.032-.03a2.892 2.892 0 0 0 .317-.415c.093-.152.159-.327.207-.5.023-.081.036-.246.04-.271.002-.016.034-.19.034-.272 0-.018 0-.037-.002-.055Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckInfo);
export default __webpack_public_path__ + "static/media/truck-info.d79e1be0a3bd9b5a00957c4fbd85cc20.svg";
export { ForwardRef as ReactComponent };